export default function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden noise-bg">
      <div className="orb -top-20 -left-32 w-[480px] h-[480px] bg-indigo-700/30" />
      <div className="orb top-10 right-[-100px] w-[400px] h-[400px] bg-blue-600/20" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(67,56,202,0.15),transparent_60%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {eyebrow && (
          <span className="inline-block text-xs uppercase tracking-[0.25em] text-blue-400 font-bold mb-4">
            {eyebrow}
          </span>
        )}
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tighter leading-[1.02] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-base md:text-lg text-zinc-400 leading-relaxed">{subtitle}</p>
        )}
        {children}
      </div>
    </section>
  );
}
